let fetch = window.fetch;
let AbortController = window.AbortController;
let Request = window.Request;

if (!('signal' in new Request(''))) {
  const { AbortController: AbortControllerPony, abortableFetch } = require('abortcontroller-polyfill/dist/cjs-ponyfill');
  const _nodeFetch = require('node-fetch');
  const { fetch: fetchPony, Request: RequestPony } = abortableFetch({fetch: _nodeFetch, Request: _nodeFetch.Request});
  fetch = fetchPony;
  AbortController = AbortControllerPony;
  Request = RequestPony;
}

module.exports = {
  fetch,
  AbortController,
  Request
};



// WEBPACK FOOTER //
// ./resources/assets/js/src/graphql/abortPolyfill.js